import { PersonSimpleRunIcon, ShoppingBagIcon } from '@phosphor-icons/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useGetClient } from '@/api/market-shop/client/get-client'
import { useGetSettingsByToken } from '@/api/market-shop/client/get-settings-by-token'
import { DeliveryRadioOption } from '@/components/business/market-shop/delivery-radio-option'
import { Typography } from '@/components/ui/typography'
import { MarketShopDeliveryType } from '@/models'

import * as S from './order-receive.styled'

export type OrderReceiveProps = {
  deliveryType: MarketShopDeliveryType
  title: string
  onDeliveryTypeChange?: (deliveryType: MarketShopDeliveryType) => void
  disabled?: boolean
}

export const OrderReceive = ({
  deliveryType,
  title,
  onDeliveryTypeChange,
  disabled = false,
}: OrderReceiveProps) => {
  const { t } = useTranslation(['market-shop'])
  const { data: settings } = useGetSettingsByToken({ enabled: !disabled })

  const canShowDeliveryOptionByAPI = disabled || (!!settings?.deliverToMe && !disabled)
  const canShowDeliveryOption =
    (!disabled || (disabled && deliveryType === 'delivery')) && canShowDeliveryOptionByAPI

  const canShowPickupOption = !disabled || (disabled && deliveryType === 'pickup')

  const { data } = useGetClient({ enabled: canShowDeliveryOption })
  const residentApartmentNumber = data?.apartment

  return (
    <S.Section>
      <Typography as="h2" size="heading-medium" weight="semibold" color="black800">
        {title}
      </Typography>

      <S.OptionsList>
        {canShowDeliveryOption && (
          <li>
            <DeliveryRadioOption
              icon={PersonSimpleRunIcon}
              title={t('market-shop:orderReceive.deliverToMe')}
              subtitle={
                residentApartmentNumber
                  ? t('market-shop:orderReceive.unit', { apartment: residentApartmentNumber })
                  : undefined
              }
              active={deliveryType === 'delivery'}
              disabled={disabled}
              onClick={() => onDeliveryTypeChange?.('delivery')}
            />
          </li>
        )}

        {canShowPickupOption && (
          <li>
            <DeliveryRadioOption
              icon={ShoppingBagIcon}
              title={t('market-shop:orderReceive.pickupMyself')}
              active={deliveryType === 'pickup'}
              disabled={disabled}
              onClick={() => onDeliveryTypeChange?.('pickup')}
            />
          </li>
        )}
      </S.OptionsList>
    </S.Section>
  )
}
